import { ListResponse } from '@commerce-cart-webcomponents/sdk';
import { createContext } from 'react';

export type CustomListContextType = {
  customList: ListResponse;
  updateCustomList: (newValue: ListResponse) => void;
};
const AllCustomListContext = createContext<CustomListContextType>({
  customList: {},
  updateCustomList: () => {
    void 0;
  },
});

export default AllCustomListContext;
